import { EventRegisterBodyDto } from '../dto/recs.dto';

type QueueItem = {
  adSlotIdentifier: string;
  payload: EventRegisterBodyDto;
};

type EventQueueOptions = {
  maxQueueSize: number;
  timeout: number;
  callback: (items: QueueItem[]) => void | Promise<void>;
}

export class EventQueue {
  private readonly queue = new Set<QueueItem>();
  private readonly options: EventQueueOptions = {
    maxQueueSize: 10,
    timeout: 5000,
    callback: () => void 0,
  };
  private timer: NodeJS.Timeout | null = null;

  public constructor (options?: Partial<EventQueueOptions>) {
    this.options = { ...this.options, ...options };
  }

  public push (item: QueueItem): void {
    this.queue.add(item);

    // Start the timer when the first item is added
    if (this.queue.size === 1) {
      this.timer = setTimeout(() => {
        this.fireEvent();
      }, this.options.timeout);
    }

    // If the queue size has reached the threshold, fire the event
    if (this.queue.size >= this.options.maxQueueSize) {
      this.fireEvent();
    }
  }

  public getItems (): QueueItem[] {
    return [ ...this.queue ];
  }

  private fireEvent (): void {
    this.options.callback(this.getItems());

    // Clear the queue
    this.queue.clear();

    // Clear the timer
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }
}
